import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Observer, of } from 'rxjs';
import { delay, map } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../environments/environment';
import { Socket } from 'ngx-socket-io';
import Utils from './dynamiclist';

// import { environment } from '@env/environment.prod';
@Injectable({
  providedIn: 'root'
})
export class libservice {
  constructor(
    private http: HttpClient,
    private socket: Socket
  ) {}

  libtocall(type: any, data: any) {
    if (type == 'prd') {
      return this.productList(data);
    }
    if (type == 'prdgrp') {
      return this.productgrouplist(data);
    }
    if (type == 'size') {
      return this.sizeList(data);
    }
    if (type == 'godown') {
      return this.godownlist(data);
    }
    if (type == 'acc') {
      return this.accList(data);
    }
    if (type == 'accfilter') {
      return this.accFilterList(data);
    }
    if (type == 'vch') {
      return this.vchList(data);
    }
    if (type == 'zone') {
      return this.zoneList(data);
    }
    if (type == 'executive') {
      return this.executiveList(data);
    }
    if (type == 'status') {
      return Utils.vstatus();
    }
    return { data: 'notfound' };
  }

  invpostdata(data: any, url: any) {
    return this.http.post(environment.apiUrl + '/invmaster/' + url, data);
  }
  invdeletedata(data: any, url: any) {
    return this.http.post(environment.apiUrl + '/invmaster/' + url, data);
  }
  getSocket(get_mal: any) {
    return new Observable((observer: Observer<any>) => {
      this.socket.on(get_mal, (data: any) => {
        observer.next(data);
      });
    });
  }

  productList(data: any) {
    return this.invpostdata(data, 'productlist');
  }
  prdwsiseList(data: any) {
    return this.invpostdata(data, 'productsslist');
  }
  productListAll(data: any) {
    return this.invpostdata(data, 'productlistall');
  }
  productget(data: any) {
    return this.invpostdata(data, 'product');
  }
  productsave(data: any) {
    return this.invpostdata(data, 'productsave');
  }
  productdelete(data: any) {
    return this.invdeletedata(data, 'productdelete');
  }
  productwithtaxlist(data: any) {
    return this.invpostdata(data, 'productwithtaxlist');
  }

  sizeList(data: any) {
    return this.invpostdata(data, 'sizelist');
  }
  sizeListAll(data: any) {
    return this.invpostdata(data, 'sizelistall');
  }
  sizeget(data: any) {
    return this.invpostdata(data, 'size');
  }
  sizesave(data: any) {
    return this.invpostdata(data, 'sizesave');
  }
  sizedelete(data: any) {
    return this.invdeletedata(data, 'sizedelete');
  }

  productgroupsave(data: any) {
    return this.invpostdata(data, 'productgroupsave');
  }
  productgroupdelete(data: any) {
    return this.invdeletedata(data, 'productgroupdelete');
  }
  productgroupget(data: any) {
    return this.invpostdata(data, 'productgroup');
  }
  productgrouplist(data: any) {
    return this.invpostdata(data, 'productgrouplist');
  }

  godownsave(data: any) {
    return this.invpostdata(data, 'godownsave');
  }
  godowndelete(data: any) {
    return this.invdeletedata(data, 'godowndelete');
  }
  godownget(data: any) {
    return this.invpostdata(data, 'godown');
  }
  godownlist(data: any) {
    return this.invpostdata(data, 'godownlist');
  }
  godownlistall(data: any) {
    return this.invpostdata(data, 'godownlistall');
  }
  unitsave(data: any) {
    return this.invpostdata(data, 'unitsave');
  }
  unitdelete(data: any) {
    return this.invdeletedata(data, 'unitdelete');
  }
  unitget(data: any) {
    return this.invpostdata(data, 'unit');
  }
  unitlist(data: any) {
    return this.invpostdata(data, 'unitlist');
  }

  seriessave(data: any) {
    return this.invpostdata(data, 'seriessave');
  }
  seriesdelete(data: any) {
    return this.invdeletedata(data, 'seriesdelete');
  }
  seriesget(data: any) {
    return this.invpostdata(data, 'series');
  }
  seriesList(data: any) {
    return this.invpostdata(data, 'serieslist');
  }

  gradesave(data: any) {
    return this.invpostdata(data, 'gradesave');
  }
  gradedelete(data: any) {
    return this.invdeletedata(data, 'gradedelete');
  }
  gradeget(data: any) {
    return this.invpostdata(data, 'grade');
  }
  gradelist(data: any) {
    return this.invpostdata(data, 'gradelist');
  }
  gradelistAll(data: any) {
    return this.invpostdata(data, 'gradelistall');
  }

  projectsave(data: any) {
    return this.invpostdata(data, 'projectsave');
  }
  projectdelete(data: any) {
    return this.invdeletedata(data, 'projectdelete');
  }
  projectget(data: any) {
    return this.invpostdata(data, 'project');
  }
  projectlist(data: any) {
    return this.invpostdata(data, 'projectlist');
  }

  categorysave(data: any) {
    return this.invpostdata(data, 'categorysave');
  }
  categorydelete(data: any) {
    return this.invdeletedata(data, 'categorydelete');
  }
  categoryget(data: any) {
    return this.invpostdata(data, 'category');
  }
  categorylist(data: any) {
    return this.invpostdata(data, 'categorylist');
  }
  bknotovchno(data: any) {
    return this.invpostdata(data, 'bknotovchno');
  }

  //end inventory master

  //start company

  companypostdata(data: any, url: any) {
    return this.http.post(environment.apiUrl + '/company/' + url, data);
  }
  companydeletedata(data: any, url: any) {
    return this.http.post(environment.apiUrl + '/company/' + url, data);
  }
  companyList(data: any) {
    return this.companypostdata(data, 'companylist');
  }
  allcompanylist(data: any) {
    return this.companypostdata(data, 'allcompanylist');
  }
  cinfo(data: any) {
    return this.companypostdata(data, 'cinfo');
  }
  companyget(data: any) {
    return this.companypostdata(data, 'company');
  }
  companysave(data: any) {
    return this.companypostdata(data, 'companysave');
  }
  companydelete(data: any) {
    return this.companydeletedata(data, 'companydelete');
  }
  //end company

  // start account master

  accpostdata(data: any, url: any) {
    return this.http.post(environment.apiUrl + '/accmaster/' + url, data);
  }

  accdeletedata(data: any, url: any) {
    return this.http.post(environment.apiUrl + '/accmaster/' + url, data);
  }

  accList(data: any) {
    return this.accpostdata(data, 'acclist');
  }
  accFilterList(data: any) {
    return this.accpostdata(data, 'acclistfilter');
  }
  accListAll(data: any) {
    return this.accpostdata(data, 'acclistall');
  }
  accget(data: any) {
    return this.accpostdata(data, 'acc');
  }
  accsave(data: any) {
    return this.accpostdata(data, 'accsave');
  }
  accdelete(data: any) {
    return this.accdeletedata(data, 'accdelete');
  }

  acgrplistfilter(data: any) {
    return this.accpostdata(data, 'acgrplistfilter');
  }

  vchList(data: any) {
    return this.accpostdata(data, 'vchlist');
  }

  accgrpList(data: any) {
    return this.accpostdata(data, 'acgrplist');
  }
  accgrpListAll(data: any) {
    return this.accpostdata(data, 'acgrplistall');
  }
  accgrpget(data: any) {
    return this.accpostdata(data, 'acgrp');
  }
  accgrpsave(data: any) {
    return this.accpostdata(data, 'acgrpsave');
  }
  accgrpdelete(data: any) {
    return this.accdeletedata(data, 'acgrpdelete');
  }

  countrysave(data: any) {
    return this.accpostdata(data, 'countrysave');
  }
  countrydelete(data: any) {
    return this.accdeletedata(data, 'countrydelete');
  }
  countryget(data: any) {
    return this.accpostdata(data, 'country');
  }
  countrylist(data: any) {
    return this.accpostdata(data, 'countrylist');
  }

  statesave(data: any) {
    return this.accpostdata(data, 'statesave');
  }
  statedelete(data: any) {
    return this.accdeletedata(data, 'statedelete');
  }
  stateget(data: any) {
    return this.accpostdata(data, 'state');
  }
  statelist(data: any) {
    return this.accpostdata(data, 'statelist');
  }

  branchList(data: any) {
    return this.accpostdata(data, 'branchlist');
  }
  branchListAll(data: any) {
    return this.accpostdata(data, 'branchlistall');
  }
  branchget(data: any) {
    return this.accpostdata(data, 'branch');
  }
  branchsave(data: any) {
    return this.accpostdata(data, 'branchsave');
  }
  branchdelete(data: any) {
    return this.accdeletedata(data, 'branchdelete');
  }

  zoneList(data: any) {
    return this.accpostdata(data, 'zonelist');
  }
  zoneListAll(data: any) {
    return this.accpostdata(data, 'zonelistall');
  }
  zoneget(data: any) {
    return this.accpostdata(data, 'zone');
  }
  zonesave(data: any) {
    return this.accpostdata(data, 'zonesave');
  }
  zonedelete(data: any) {
    return this.accdeletedata(data, 'zonedelete');
  }

  executiveList(data: any) {
    return this.accpostdata(data, 'executivelist');
  }
  executiveListAll(data: any) {
    return this.accpostdata(data, 'executivelistall');
  }
  executiveget(data: any) {
    return this.accpostdata(data, 'executive');
  }
  executivesave(data: any) {
    return this.accpostdata(data, 'executivesave');
  }
  executivedelete(data: any) {
    return this.accdeletedata(data, 'executivedelete');
  }

  transportList(data: any) {
    return this.accpostdata(data, 'transportlist');
  }
  transportListAll(data: any) {
    return this.accpostdata(data, 'transportlistall');
  }
  transportget(data: any) {
    return this.accpostdata(data, 'transport');
  }
  transportsave(data: any) {
    return this.accpostdata(data, 'transportsave');
  }
  transportdelete(data: any) {
    return this.accdeletedata(data, 'transportdelete');
  }

  salestypeList(data: any) {
    return this.accpostdata(data, 'salestypelist');
  }
  taxaccfind(data: any) {
    return this.accpostdata(data, 'taxaccfind');
  }

  // transaction start
  tranpostdata(data: any, url: any) {
    return this.http.post(environment.apiUrl + '/vch/' + url, data);
  }
  trandeletedata(data: any, url: any) {
    return this.http.post(environment.apiUrl + '/vch/' + url, data);
  }

  salesorderList(data: any) {
    return this.tranpostdata(data, 'salesorder');
  }
  // accListAll(data: any) {
  //   return this.accpostdata(data, 'acclistall')
  // }
  // accget(data: any) {
  //   return this.accpostdata(data, 'acc')
  // }
  salesordersave(data: any) {
    return this.tranpostdata(data, 'salesordersave');
  }
  // accdelete(data: any) {
  //   return this.accdeletedata(data, 'accdelete')
  // }
  salesvoucherget(data: any) {
    return this.tranpostdata(data, 'voucher');
  }
  salesvouchersave(data: any) {
    return this.tranpostdata(data, 'voucher');
  }
  getSalesAllMasterList(data: any) {
    return this.tranpostdata(data, 'getsalesallmasterlist');
  }
  getPurchaseAllMasterList(data: any) {
    return this.tranpostdata(data, 'getpurchaseallmasterlist');
  }
  despatchstatus(data: any) {
    return this.tranpostdata(data, 'despatchstatus');
  }
  productionsave(data: any) {
    return this.tranpostdata(data, 'voucher');
  }

  voucherstockjournal(data: any) {
    return this.tranpostdata(data, 'voucherstockjournal');
  }

  voucherdelete(data: any) {
    return this.tranpostdata(data, 'voucherdel');
  }

  voucherupdown(data: any) {
    return this.tranpostdata(data, 'voucherupdown');
  }

  maxvchno(data: any) {
    return this.tranpostdata(data, 'maxvchno');
  }
  prdrate(data: any) {
    return this.tranpostdata(data, 'prdrate');
  }
  ordlastrate(data: any) {
    return this.tranpostdata(data, 'ordlastrate');
  }

  salesinvprint(data: any) {
    return this.tranpostdata(data, 'saleinvprint');
  }
  getexecutivetarget(data: any) {
    return this.tranpostdata(data, 'getexecutivetarget');
  }
  saveexecutivetarget(data: any) {
    return this.tranpostdata(data, 'saveexecutivetarget');
  }
  getacctozoneexc(data: any) {
    return this.tranpostdata(data, 'getacctozoneexc');
  }
  billsundrymaster(data: any) {
    return this.tranpostdata(data, 'billsundrymaster');
  }
  cashaccidget(data: any) {
    return this.tranpostdata(data, 'cashaccidget');
  }
  // transaction end

  // config start
  configpostdata(data: any, url: any) {
    return this.http.post(environment.apiUrl + '/config/' + url, data);
  }
  billsunderyfldlist(data: any) {
    return this.configpostdata(data, 'billsunderyfldlist');
  }
  billsunderymslist(data: any) {
    return this.configpostdata(data, 'billsunderymslist');
  }
  billsunderymssave(data: any) {
    return this.configpostdata(data, 'billsunderymssave');
  }
  trantablefldlist(data: any) {
    return this.configpostdata(data, 'trantablefldlist');
  }
  trantablemslist(data: any) {
    return this.configpostdata(data, 'trantablemslist');
  }
  trantablemssave(data: any) {
    return this.configpostdata(data, 'trantablemssave');
  }
  trantablearraylist(data: any) {
    return this.configpostdata(data, 'trantablearraylist');
  }
  defaultdataconfigsave(data: any) {
    return this.configpostdata(data, 'defaultdataconfigsave');
  }
  // config end

  // web user start
  webuserpostdata(data: any, url: any) {
    return this.http.post(environment.apiUrl + '/webuser/' + url, data);
  }

  webuserdeletedata(data: any, url: any) {
    return this.http.post(environment.apiUrl + '/webuser/' + url, data);
  }
  webuserList(data: any) {
    return this.webuserpostdata(data, 'userlist');
  }

  webuserget(data: any) {
    return this.webuserpostdata(data, 'user');
  }
  webusersave(data: any) {
    return this.webuserpostdata(data, 'usersave');
  }
  webuserdelete(data: any) {
    return this.webuserpostdata(data, 'userdelete');
  }
  webuserroleList(data: any) {
    return this.webuserpostdata(data, 'userrolelist');
  }

  useraccess(data: any) {
    return this.webuserpostdata(data, 'useraccess');
  }
  useraccesssave(data: any) {
    return this.webuserpostdata(data, 'useraccesssave');
  }
  getuserlist(data: any) {
    return this.webuserpostdata(data, 'getuserlist');
  }
  getuseraccessvch(data: any) {
    return this.webuserpostdata(data, 'getuseraccessvch');
  }
  getuseraccessmenu(data: any) {
    return this.webuserpostdata(data, 'getuseraccessmenu');
  }
  // web user end

  //utilities start
  // utilitiesreportdata(data: any, url: any) {
  //   return this.http.post(environment.apiUrl + '/arep/' + url, data);
  // }
  // accreportdeletedata(data: any, url: any) {
  //   return this.http.delete(environment.apiUrl + '/arep/' + url, {
  //     body: data
  //   });
  // }

  //utilities end

  //other start

  //other end
  //account Reports start
  accreportdata(data: any, url: any) {
    return this.http.post(environment.apiUrl + '/arep/' + url, data);
  }
  accreportdeletedata(data: any, url: any) {
    return this.http.post(environment.apiUrl + '/arep/' + url, data);
  }
  ledgerget(data: any) {
    return this.accreportdata(data, 'ledger');
  }
  daybookget(data: any) {
    return this.accreportdata(data, 'daybook');
  }
  trialbalanceget(data: any) {
    return this.accreportdata(data, 'trialbalance');
  }
  salesordregister(data: any) {
    return this.accreportdata(data, 'salesordregister');
  }
  //account Reports end

  //Stock Report start
  stockreportdata(data: any, url: any) {
    return this.http.post(environment.apiUrl + '/irep/' + url, data);
  }
  gradewisestock(data: any) {
    return this.stockreportdata(data, 'gradewisestock');
  }

  stockitem(data: any) {
    return this.stockreportdata(data, 'stockitem');
  }
  stockgroupsummary(data: any) {
    return this.stockreportdata(data, 'stockgroupsummary');
  }
  productionreport(data: any) {
    return this.stockreportdata(data, 'productionreport');
  }
  //Stock Report end

  //Mis Report start
  misreportdata(data: any, url: any) {
    return this.http.post(environment.apiUrl + '/misrep/' + url, data);
  }
  exctargetachive(data: any) {
    return this.misreportdata(data, 'exctargetachive');
  }
  //Mis Report end
  // Dashbord
  dashboard(data: any) {
    return this.http.post(environment.apiUrl + '/dashboard/dashboard', data);
  }

  private dataSubject = new BehaviorSubject<any[]>([]); // BehaviorSubject for table data

  // Clears the current data
  clearData() {
    this.dataSubject.next([]); // Emit an empty array to clear the table data
  }
}
